import React from 'react';
import { useMotion } from '../../context/MotionContext';

const ScanlineOverlay = () => {
  const { prefersReducedMotion } = useMotion();

  if (prefersReducedMotion) return null;

  return (
    <>
      {/* Animated scanline */}
      <div
        className="fixed inset-0 pointer-events-none z-[9999]"
        style={{
          background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 255, 209, 0.02) 2px, rgba(0, 255, 209, 0.02) 4px)',
        }}
      />
      {/* Moving scanline */}
      <div
        className="fixed left-0 right-0 h-px pointer-events-none z-[9999] animate-scanline"
        style={{
          background: 'linear-gradient(90deg, transparent, rgba(0, 255, 209, 0.3), transparent)',
        }}
      />
    </>
  );
};

export default ScanlineOverlay;
